import http from './http';

class UsersService {
    getMe(){
        return http.get('/user/me');
    }

    getProfessionalsOnly(){
        return http.get('/user/professionals');
    }

    getUsers(params) {
        return http.get('/users', { params });
    }

    getUser(id) {
        return http.get(`/users/${id}`);
    }

    getPayments(params) {
        return http.get(`/user/payments`, { params });
    }

    createUser(payload) {
        return http.post('/users', payload);
    }

    editUser(id, payload) {
        return http.put(`/users/${id}`, payload);
    }

    archiveUser(id) {
        return http.delete(`/users/${id}`);
    }

    reactivateUser(id) {
        return http.patch(`/users/${id}/restore`);
    }
}

export default new UsersService(); 
